import React from 'react'
import { useQuery, useQueries } from "@tanstack/react-query"
import Loader from 'components/general/Loader';
import { filterArray, findArray } from "helpers/utils"
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import Label from "components/general/Label"
import { getPoolStanding, getPhases } from "data/Querys"
import { getEventRSC, getLongPhaseRSC, getPhaseRSC, getEvent } from "helpers/rsc"
import PoolStanding from 'components/sports/glo/poolstanding/views/PoolStanding';
import ProgressionRule from 'components/common/ProgressionRule'
import NotAvailable from 'components/common/NotAvailable'
import { useViewport } from 'components/general/useViewPort'
import PageHeader from 'components/common/PageHeader';
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";
import { useGetConfigSports } from 'helpers/commonCodes';
import SportCode from "components/common/SportCode";
import { LegendProvider } from "components/common/legendContext";
import { CleanLegends } from 'components/common/CleanLegends';
import { LegendsBox } from 'components/common/LegendsBox';

function PoolStandingContext() {

    //Get data from url 
    const { mirs_competition, mirs_event, mirs_language, mirs_discipline } = useUrlFriendlyToParameters()
    const params = { 'mirs_competition': mirs_competition, 'mirs_discipline': mirs_discipline }
    const _event = getEventRSC(mirs_event);
    const _onlyEvent = getEvent(mirs_event);
    const { breakPoint } = useViewport();
    const dataConfigSport = useGetConfigSports(params);
    //Load data from config file

    let filter = breakPoint === 'sm' || breakPoint === 'xs' ? 'sm' : 'lg';
    let poolValues = dataConfigSport?.pool?.find(media => media.code === filter && media.codeEvent === _onlyEvent)?.table
    if (!poolValues) {
        poolValues = dataConfigSport?.pool?.find(media => media.code === filter)?.table
    }
    let combinedValues = dataConfigSport?.combinedRanking?.find(media => media.code === filter)?.table

    let isList = poolValues?.isList


    //Load data Phases
    const { data: phasesData, isError: phasesError, isLoading: phasesLoading } = useQuery(
        {
            queryKey: ['phasesData', mirs_competition, mirs_language, _event],
            queryFn: getPhases,
            enabled: isList, //--------------------
            refetchInterval: 60000,
            refetchIntervalInBackground: true,
        });

    //Filter phases we need
    let queryArray = [];
    //let phases = phasesData && filterArray(phasesData, { order: ['8  '] })

    let phases = phasesData && phasesData.filter(phase => phase?.order?.trim() === '8')


    // To Review
    /*
    if (!isList) {
        let phasesNounits = phases && phases.filter(item => !item.units)
        phases = phases && filterArray(phases, { code: [getPhaseRSC(mirs_event)] })
        phases = phases && [...phases, ...phasesNounits]
    }
    */

    //Filter phases by order 8 (Pooles)
    phases && phases.forEach((phase) => {
        queryArray.push({
            queryKey: ['poolData', mirs_competition, getLongPhaseRSC(phase.code), mirs_language],
            queryFn: getPoolStanding,
            refetchInterval: 30000
        })
    });


    const pools = useQueries({ queries: queryArray });//Data all pools
    const isLoading = phasesLoading || pools.some(pool => pool.isLoading)
    const isError = phasesError || pools.some(pool => pool.isError)

    if (isError) { return <NotAvailable label={"LabelNoDataGroups"} />; }
    if (isLoading) { return <Loader />; }


    if ((pools && pools.length < 1) || (pools && pools?.filter(p => p?.data?.poolStandings).length < 1)) return <NotAvailable label={"LabelNoDataGroups"} />

    return (
        <>
            {mirs_discipline === 'BKG'
                ? <PageHeader title={<SportCode discipline={mirs_discipline} entity='@Event' code={mirs_event} />} showEvent={true} />
                : <PageHeader title={<Label data="LabelGroup" />} showEvent={true} />
            }

            <div className='mirs-page-container'>
                {pools?.find(p => p?.data?.poolStandings?.extendedInfos !== undefined) && <ProgressionRule
                    //className='mx-2 mb-5'
                    data={pools?.find(p => p?.data?.poolStandings?.extendedInfos !== undefined)?.data?.poolStandings?.extendedInfos}
                    filter={{ ei_type: ['UI'], ei_code: ['QUAL_RULE'] }}
                    itemData='ei_value'
                />
                }

                {
                    dataConfigSport && dataConfigSport.hasCombinedRanking && !['RU7'].includes(mirs_discipline)
                        ? <Tabs
                            id="mirs-navsport"
                            className="mirs-tab-result nav nav-tabs"
                            defaultActiveKey={`1-${mirs_discipline}`} //mirs_event was bugging and we couldnt change pools and get the default properly
                        >
                            <Tab eventKey={`1-${mirs_discipline}`} title={<Label data="Groups" sport={mirs_discipline} />} >
                                <DrawPooles pools={pools} phases={phases} columns={poolValues.columns} />
                            </Tab>

                            <Tab eventKey={`2-${mirs_discipline}`} title={<Label data="CombinedRanking" sport={mirs_discipline} />} >
                                <DrawPooles pools={pools} phases={phases} columns={combinedValues.columns} isCombined={true} />
                            </Tab>
                        </Tabs>
                        :

                        dataConfigSport && dataConfigSport.hasPool
                            ?
                            <>
                                <LegendProvider>
                                    <CleanLegends />
                                    <DrawPooles pools={pools} phases={phases} columns={poolValues.columns} />
                                    {dataConfigSport && dataConfigSport.hasCombinedRanking && ['RU7'].includes(mirs_discipline)
                                        ? <DrawPooles pools={pools} phases={phases} columns={combinedValues.columns} isCombined={true} />
                                        : ''
                                    }
                                    <LegendsBox />
                                </LegendProvider>
                            </>
                            : ''
                }
            </div>
        </>
    );

}



const DrawPooles = ({ pools, phases, columns, isCombined = false }) => {

    return (
        pools.map((dataPool, index) => {
            let phaseRsc = getPhaseRSC(dataPool?.data?.poolStandings?.rsc);
            let check
            let label
            if (isCombined) {
                label = 'combined-ranking-component'
                check = phases && phaseRsc.endsWith("--")

            } else {
                label = 'pool-component'
                check = phases && !phaseRsc.endsWith("--")
            }
            return (
                // phases && findArray(phases, { code: [phaseRsc] }).units &&
                check &&
                <PoolStanding key={`${label}-${index}`} data={dataPool.data.poolStandings} columns={columns} isCombinedRanking={isCombined} />
            )
        })
    )


}

export default PoolStandingContext